// extracted by mini-css-extract-plugin
module.exports = {"external-link":"ExternalLinkV2_external-link__o_k7c","externalLink":"ExternalLinkV2_external-link__o_k7c"};